<template>
  <div>
    <v-container>
      <div>
        <v-row>
          <v-col cols="12" md="7" style="">
            <v-form ref="form" class="mx-2" lazy-validation>
              <v-row>
                <v-col cols="12" md="12">
                  <v-card color="#f4e1f7" elevation="0" class="pa-2 my-2">
                    <div class="d-flex justify-space-around">
                      <div class="text px-3">
                        <span class="grey--text">نام تجاری:</span>
                        <span class="secondary--text mr-1">{{
                          localData.agent.businessName
                        }}</span>
                      </div>
                      <div class="text px-3">
                        <span class="grey--text">شهر:</span>
                        <span class="secondary--text mr-1">{{
                          localData.agent.city
                        }}</span>
                      </div>
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-money ref="amount" v-model="localData.amount" :label="'*مبلغ'" :error-messages="errorMessages" :rules="[
                    () =>
                      localData.amount > 0 || 'مبلغ را به صورت صحیح وارد کنید'
                  ]" required />
                </v-col>
                <v-col cols="12" md="6">
                  <div>
                    <div>تاریخ واریز*</div>
                    <date-picker ref="saveDate" v-model="localData.saveDate" format="YYYY-MM-DDTHH:mm:ss" auto-submit display-format="jYYYY/jMM/jDD" :error-messages="errorMessages" :rules="[
                      () =>
                        !!localData.saveDate ||
                        'تاریخ واریز را به صورت صحیح وارد کنید'
                    ]" />
                  </div>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="12">
                  <v-text-field ref="description" v-model="localData.description" :label="'توضیحات تراکنش'" :error-messages="errorMessages" />
                </v-col>
              </v-row>

              <v-row v-if="agentFactor">
                <v-col cols="12">
                  <div class="info--text">مشخصات صورتحساب انتخاب شده:</div>
                  <v-card class="pa-2 d-flex" color="#d1ebff" elevation="0">
                    <v-checkbox style="" :disabled="true" color="info" v-model="agentFactor.checked" :value="true" />
                    <div style="width:100%">
                      <v-row class="ma-0">
                        <v-col cols="6" class="pa-1 my-0 text-right">
                          <small class="info--text text--darken-2">شماره سیستمی:</small>
                          <span class="mr-1 grey--text">{{
                            agentFactor.code
                          }}</span>
                        </v-col>
                        <v-col cols="6" class="pa-1 my-0 text-right">
                          <small class="info--text text--darken-2">تاریخ صورتحساب:</small>
                          <span class="mr-1 grey--text">{{
                            agentFactor.createAt_Persian.date
                          }}</span>
                        </v-col>
                      </v-row>
                      <v-row class="ma-0">
                        <v-col cols="6" class="pa-1 my-0 text-right">
                          <small class="info--text text--darken-2">مبلغ صورتحساب:</small>
                          <span class="mr-1 grey--text">{{
                            agentFactor.amount.toString().toPriceFormat()
                          }}</span>
                          <small class="mr-1 grey--text">تومان</small>
                        </v-col>
                        <v-col cols="6" class="pa-1 my-0 text-right">
                          <small class="info--text text--darken-2">پرداختی مشتری:</small>
                          <span class="mr-1 grey--text">{{
                            payedAmountOfFactorByCustomer(agentFactor).toString().toPriceFormat()
                          }}</span>
                          <small class="mr-1 grey--text">تومان</small>
                        </v-col>
                        <v-col cols="12" class="pa-1 my-0 text-right">
                          <small class="info--text text--darken-2">مبلغ تسویه نشده با نماینده:</small>
                          <span class="mr-1 grey--text">&lrm;{{
                            (payedAmountOfFactorByCustomer(agentFactor) - agentFactor.sumWithdraws -
                              agentFactor.commission)
                              .toString()
                              .toPriceFormat()
                          }}</span>
                        </v-col>
                      </v-row>
                    </div>
                  </v-card>
                </v-col>
              </v-row>

              <v-row v-if="otherAgentFactors.length || loadOtherAgentFactorsLoading">
                <v-col cols="12">
                  <div class="">
                    سایر صورتحساب های تسویه نشده نماینده:
                    <span class="info--text">(مجموع: {{ sumOthersRemain.toString().toPriceFormat() }}
                      <small>تومان</small>)</span>
                  </div>
                  <v-progress-linear v-if="loadOtherAgentFactorsLoading" :size="50" color="primary" indeterminate />
                  <v-card class="pa-2 d-flex mb-2" color="#eee" elevation="0" v-for="other in otherAgentFactors" :key="other.id">
                    <v-checkbox style="" color="grey" v-model="other.checked" :value="true" @change="otherAgentFactorCheckChanged" />
                    <div style="width:100%">
                      <v-row class="ma-0">
                        <v-col cols="6" class="pa-1 my-0 text-right">
                          <small class="grey--text text--darken-2">شماره سیستمی:</small>
                          <span class="mr-1 grey--text">{{ other.code }}</span>
                        </v-col>
                        <v-col cols="6" class="pa-1 my-0 text-right">
                          <small class="grey--text text--darken-2">تاریخ صورتحساب:</small>
                          <span class="mr-1 grey--text">{{
                            other.createAt_Persian.date
                          }}</span>
                        </v-col>
                      </v-row>
                      <v-row class="ma-0">
                        <v-col cols="6" class="pa-1 my-0 text-right">
                          <small class="grey--text text--darken-2">مبلغ صورتحساب:</small>
                          <span class="mr-1 grey--text">{{
                            other.amount.toString().toPriceFormat()
                          }}</span>
                          <small class="mr-1 grey--text">تومان</small>
                        </v-col>
                        <v-col cols="6" class="pa-1 my-0 text-right">
                          <small class="grey--text text--darken-2">پرداختی مشتری:</small>
                          <span class="mr-1 grey--text">{{
                            payedAmountOfFactorByCustomer(other).toString().toPriceFormat()
                          }}</span>
                          <small class="mr-1 grey--text">تومان</small>
                        </v-col>
                        <v-col cols="12" class="pa-1 my-0 text-right">
                          <small class="grey--text text--darken-2">مبلغ تسویه نشده با نماینده:</small>
                          <span class="mr-1 grey--text">&lrm;{{
                            (payedAmountOfFactorByCustomer(other) - other.sumWithdraws - other.commission)
                              .toString()
                              .toPriceFormat()
                          }}</span>
                        </v-col>
                      </v-row>
                    </div>
                  </v-card>
                </v-col>
              </v-row>

              <v-row v-if="agentFactors.length || loadAgentFactorsLoading">
                <v-col cols="12">
                  <div class="">
                    صورتحساب های تسویه شده در این تراکنش:
                  </div>
                  <v-progress-linear v-if="loadAgentFactorsLoading" :size="50" color="primary" indeterminate />
                  <v-card class="pa-2 d-flex mb-2" color="#eee" elevation="0" v-for="factor in agentFactors" :key="factor.id">
                    <v-checkbox style="" color="grey" v-model="factor.checked" :value="true" @change="agentFactorCheckChanged" />
                    <div style="width:100%">
                      <v-row class="ma-0">
                        <v-col cols="6" class="pa-1 my-0 text-right">
                          <small class="grey--text text--darken-2">شماره سیستمی:</small>
                          <span class="mr-1 grey--text">{{ factor.code }}</span>
                        </v-col>
                        <v-col cols="6" class="pa-1 my-0 text-right">
                          <small class="grey--text text--darken-2">تاریخ صورتحساب:</small>
                          <span class="mr-1 grey--text">{{
                            factor.createAt_Persian.date
                          }}</span>
                        </v-col>
                      </v-row>
                      <v-row class="ma-0">
                        <v-col cols="6" class="pa-1 my-0 text-right">
                          <small class="grey--text text--darken-2">مبلغ صورتحساب:</small>
                          <span class="mr-1 grey--text">{{
                            factor.amount.toString().toPriceFormat()
                          }}</span>
                          <small class="mr-1 grey--text">تومان</small>
                        </v-col>
                        <v-col cols="6" class="pa-1 my-0 text-right">
                          <small class="grey--text text--darken-2">پرداختی مشتری:</small>
                          <span class="mr-1 grey--text">{{
                            payedAmountOfFactorByCustomer(factor).toString().toPriceFormat()
                          }}</span>
                          <small class="mr-1 grey--text">تومان</small>
                        </v-col>
                        <v-col cols="12" class="pa-1 my-0 text-right">
                          <small class="grey--text text--darken-2">مبلغ تسویه نشده با نماینده:</small>
                          <span class="mr-1 grey--text">{{
                            (factor.amount - factor.sumWithdraws - factor.commission)
                              .toString()
                              .toPriceFormat()
                          }}</span>
                        </v-col>
                      </v-row>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
          <v-col cols="12" md="5">
            <div style="border-bottom:1px dashed #ddd; text-align: center; margin-bottom: 10px;display: flex;justify-content: center">
              <v-icon style="transform:rotate(-45deg)">mdi-attachment</v-icon>
              <span>فایل پیوست</span>
            </div>
            <ImageUploader ref="imageUploader" v-model="localData.base64" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(localData.base64)" @delete="() => (localData.fileName = '')" />
            <ImageUploader v-if="showMore" ref="imageUploader2" class="mt-5" v-model="localData.base642" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(localData.base642)" @delete="() => (localData.fileName2 = '')" />
            <ImageUploader v-if="showMore" ref="imageUploader3" class="mt-5" v-model="localData.base643" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(localData.base643)" @delete="() => (localData.fileName3 = '')" />
            <div class="text-center mt-3" v-if="!showMore">
              <v-btn text color="secondary" x-small @click="showMore = true">
                <v-icon class="ml-1" small>mdi-plus</v-icon>
                پیوست های بیشتر
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-container>

    <v-card-actions>
      <v-spacer />
      <v-btn @click="$emit('callbck', false)">
        بستن
      </v-btn>
      <v-btn color="blue" dark :loading="submitLoading" @click="submit()" v-if="area === 'admin'">
        ذخیره
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
  import { emptyId } from "@/util/emptyId"
  import api from "@/util/app-api"
  import toast from "@/util/toast"
  import VuePersianDatetimePicker from "vue-persian-datetime-picker"
  import ImageUploader from "@/components/uploader/ImageUploader"
  import { call, get } from "vuex-pathify"
  import { obj2FormData } from "@/util/helpers.js"
  import { cloneDeep } from "lodash"

  export default {
    name: "ModifyAgentFactorcCheckoutTransaction",
    components: {
      "date-picker": VuePersianDatetimePicker,
      ImageUploader
    },
    props: {
      data: { type: Object },
      area: { type: String },
      agentFactor: { type: Object }
    },
    data() {
      return {
        showMore: false,
        overlayImgSrc: "",
        overlay: false,
        errorMessages: "",
        localData: { paymentMethod: 1, base64: "", agent: {} },
        submitLoading: false,
        loadAgentFactorsLoading: false,
        loadOtherAgentFactorsLoading: false,
        agentFactors: [],
        otherAgentFactors: []
      }
    },
    computed: {
      ...get("appSettings", ["settings"]),
      sumOthersRemain() {
        let sum = 0
        for (let i of this.otherAgentFactors) {
          sum += Number(this.payedAmountOfFactorByCustomer(i) - i.sumWithdraws - i.commission)
        }
        return sum
      },
      sumSelectedOthers() {
        let sum = 0
        for (let i of this.otherAgentFactors.filter(x => x.checked)) {
          sum += Number(this.payedAmountOfFactorByCustomer(i) - i.sumWithdraws - i.commission)
        }
        return sum
      },
      sumSelectedAgentFactors() {
        let sum = 0
        for (let i of this.agentFactors.filter(x => x.checked)) {
          sum += Number(this.payedAmountOfFactorByCustomer(i) - i.sumWithdraws - i.commission)
        }
        return sum
      },
      agentFactorRemain() {
        if (!this.agentFactor) return 0
        return this.payedAmountOfFactorByCustomer(this.agentFactor) - this.agentFactor.sumWithdraws - this.agentFactor.commission
      }
    },
    mounted() {
      this.localData = cloneDeep(this.data)
      if (this.localData.id !== emptyId) this.loadAgentFactors()
      else {
        this.localData.saveDate = new Date().toISOString()
        this.loadOtherNotCheckoutedAagentFactors()
      }
    },
    methods: {
      payedAmountOfFactorByCustomer(factor) {
        if (!factor?.checkoutType)
          return 0
        return factor?.checkoutType === 3 ? factor?.memberPurchase?.amount || 0 : factor.amount
      },
      loadAgentFactors() {
        this.loadAgentFactorsLoading = true
        api
          .get(`${this.area}AgentFactor/ListByTransactionId/${this.localData.id}`, null)
          .then(response => {
            this.agentFactors = response.map(x => {
              x.checked = true
              return x
            })
          })
          .catch(err => {
            toast.error(err.message)
          })
          .finally(x => {
            this.loadAgentFactorsLoading = false
          })
      },
      submit() {
        // کد زیر در حالت ایجاد ترنزکشن مجموع باقیمانده فاکتور ها صفر می شودو در حالت ویرایش مجموع سایر و جاری صفر میشه
        if (this.localData.amount !== this.sumSelectedOthers + this.agentFactorRemain + this.sumSelectedAgentFactors) {
          toast.error(
            "مبلغ وارد شده مغایر با مجموع تسویه نشده صورتحساب(ها) است."
          )
          return
        }
        if (!this.$refs.form.validate()) {
          toast.error("ابتدا موارد فرم را تکمیل نمایید.")
          return
        }
        this.submitLoading = true
        let data = {}
        Object.assign(data, this.localData)
        delete data.base64
        delete data.base642
        delete data.base643
        delete data.saveDate_Persian

        data.agentFactors = []
        if (this.sumSelectedAgentFactors > 0)
          data.agentFactors.push(
            ...this.agentFactors
              .filter(x => x.checked)
              .map(x => {
                return { id: x.id, code: x.code }
              })
          )
        if (this.sumSelectedOthers > 0)
          data.agentFactors.push(
            ...this.otherAgentFactors
              .filter(x => x.checked)
              .map(x => {
                return { id: x.id, code: x.code }
              })
          )
        if (this.agentFactor)
          data.agentFactors.push({
            id: this.agentFactor.id,
            code: this.agentFactor.code
          })

        const formData = obj2FormData(data)
        var fileUploader = this.$refs["imageUploader"]
          ? this.$refs["imageUploader"]
          : null
        if (fileUploader && fileUploader.hasFile()) {
          formData.append("file", fileUploader.getFile())
        }
        var fileUploader2 = this.$refs["imageUploader2"]
          ? this.$refs["imageUploader2"]
          : null
        if (fileUploader2 && fileUploader2.hasFile()) {
          formData.append("file2", fileUploader2.getFile())
        }
        var fileUploader3 = this.$refs["imageUploader3"]
          ? this.$refs["imageUploader3"]
          : null
        if (fileUploader3 && fileUploader3.hasFile()) {
          formData.append("file3", fileUploader3.getFile())
        }
        api
          .post(
            "admin/transaction/" +
            (this.localData.id === emptyId
              ? "CreateAgentFactorTransaction"
              : "EditAgentFactorTransaction"),
            formData,
            { contentType: "multipart/form-data" }
          )
          .then(response => {
            toast.success("اطلاعات با موفقیت ذخیره شد.")
            this.$emit("callbck", true)
          })
          .catch(err => {
            toast.error(err.message)
          })
          .finally(x => {
            this.submitLoading = false
          })
      },
      loadOtherNotCheckoutedAagentFactors() {
        this.loadOtherAgentFactorsLoading = true
        api
          .get(`admin/AgentFactor/list?agentId=${this.localData.agent.id}`, null)
          .then(response => {
            this.otherAgentFactors = response.filter(
              x => x.id !== this.agentFactor?.id && this.payedAmountOfFactorByCustomer(x) - x.sumWithdraws - x.commission > 0
            )
          })
          .catch(err => {
            toast.error(err.message)
          })
          .finally(x => {
            this.loadOtherAgentFactorsLoading = false
          })
      },
      viewImage(img) {
        this.overlay = true
        this.overlayImgSrc = img
      },
      otherAgentFactorCheckChanged() {
        let sum = this.payedAmountOfFactorByCustomer(this.agentFactor) - this.agentFactor.sumWithdraws - this.agentFactor.commission
        for (let i of this.otherAgentFactors.filter(x => x.checked)) {
          sum += Number(this.payedAmountOfFactorByCustomer(i) - i.sumWithdraws - i.commission)
        }
        this.localData.amount = sum
      },
      agentFactorCheckChanged() {
        let sum = 0
        for (let i of this.agentFactors.filter(x => x.checked)) {
          sum += Number(this.payedAmountOfFactorByCustomer(i) - i.sumWithdraws - i.commission)
        }
        this.localData.amount = sum
      }
    }
  }
</script>
<style></style>
